.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.flush {
  max-width: none;
  padding: 0;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
